// extracted by mini-css-extract-plugin
export var chip = "_ci-0";
export var filterDropdown = "_ci-5";
export var filterItem = "_ci-6";
export var icon = "_ci-1";
export var removeButton = "_ci-3";
export var removeIcon = "_ci-4";
export var separator = "_ci-2";